var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/isarray/index.js
// module id = 469
// module chunks = 13